export function ValidationSupplier(supplier) {
    const result = {
        success: false,
        message: ""
    };

    if (!supplier) {
        result.message = "please enter supplier data";
        return result;
    }

    if (!supplier.supplierCompany?.trim()) {
        result.message = "please enter supplier name";
        return result;
    }

    if (!/^\d{7,15}$/.test(supplier.phone)) {
        result.message = "phone number must be between 7 and 15 digits";
        return result;
    }

    if (!supplier.contactPersonName?.trim()) {
        result.message = "please enter contact person name";
        return result;
    }

    return {
        success: true,
        message: ""
    };
}